import styled from "styled-components";
import FastingInstructions from "./FastingInstruction";

export default function FastingInstructionsFeed({
  generalFastingInstructions, 
  tubeFastingInstructions,
}) {
  // const tubeFastingInstructions = fastingInstructions?.tube;

  return (
    <Container>
      { generalFastingInstructions && 
        generalFastingInstructions.map((instruction, i) => 
          <FastingInstructions
            key={`gfi${i}`}
            {...instruction}
          />
        )
      }

      <HL />

      <SubTitle> If you have a feeding tube: </SubTitle>

      { tubeFastingInstructions && 
        tubeFastingInstructions.map((instruction, i) => 
          <FastingInstructions
            key={`gfi${i}`}
            {...{...instruction, noHL: true}}
          />
        )

      }

      <HL />

      <SubTitle> Lastly, is this diet safe if I have diabetes? </SubTitle>
      <Text> A clear liquid diet can be safe for people who have diabetes. However, you may need to follow special instructions. For example, you may need to make other diet changes. Or you may need to make changes to the medicines you take for diabetes. Talk with the healthcare professional who manages your diabetes. </Text>
    </Container>

  );
}

const Container = styled.div`
  padding-bottom: 11px;
`

const HL = styled.div`
  height: 1px;
  background-color: #CCD9FB;
  margin-block: 35px;
`

const SubTitle = styled.p`
  font-size: 22px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 34px;
`

const Text = styled.p`
  font-size: 19px;
  font-weight: 400;
  margin: 0;
`